import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Flex,
  Heading,
  Box,
  Button,
  Text
} from '@chakra-ui/react';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import * as api from '../../../../api/redesSociais';

import { useParams } from 'react-router-dom';
import {
  Spinner,
  FormControl,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookSquare, faInstagram, faLinkedin, faYoutube,
  faTiktok, faXTwitter, faWhatsapp, faTelegram, faTumblrSquare,
  IconDefinition
} from '@fortawesome/free-brands-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
interface RedeSocial {
  codRede: number;
  dscRede: string;
}

const iconData: { [key: number]: { icon: IconDefinition; color: string } } & { default: { icon: IconDefinition; color: string } } = {
  0: { icon: faFacebookSquare, color: "#1789fc" },
  1: { icon: faInstagram, color: "#ec1393" },
  2: { icon: faLinkedin, color: "#1DA1F2" },
  3: { icon: faYoutube, color: "#ff0000" },
  4: { icon: faTiktok, color: "#080404" },
  5: { icon: faXTwitter, color: "#080404" },
  6: { icon: faWhatsapp, color: "#43e460" },
  7: { icon: faTelegram, color: "#088ccc" },
  8: { icon: faTumblrSquare, color: "#384c5c" },
  default: { icon: faGlobe, color: "#3b87d8" }
};

const ListaIconesPublicacaoRedeSocial = () => {
  const [redes, setRedes] = useState<any[]>([]);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [tamanhoPagina, setTamanhoPagina] = useState(10);
  const [loading, setLoading] = useState<boolean>(false);
  const [listagemRedes, setListagemRedes] = useState<[]>([]);
  const [listagemPublicacao, setListagemPublicacao] = useState<[]>([]);
  const [listagemIcones, setListagemIcones] = useState<RedeSocial[]>([]);

  const navigate = useNavigate();
  const { codRede } = useParams();

  useEffect(() => {
    const fetchIconeRedeSocial = async () => {
      setLoading(true);
      try {
        const data = await api.listarRedesSociais(paginaAtual, tamanhoPagina);
        setListagemIcones(data.formatoArquivos);
      } catch (error) {
        console.error('Erro ao buscar ícones de redes sociais:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchIconeRedeSocial();
  }, []);

  useEffect(() => {
    if (codRede) {
      const fetchRedeSocial = async () => {
        setLoading(true);
        try {
          const data = await api.listarPublicacaoRedesSociais(Number(codRede), paginaAtual, tamanhoPagina);
          if (data && Array.isArray(data.conteudo)) {
            setListagemPublicacao(data.conteudo.map((publicacao: any) => ({
              seqConteudo: publicacao.seqConteudo ?? '',
              nomePublicacao: publicacao.nomePublicacao ?? '',
              datRegistro: publicacao.datRegistro ?? '',
              datPublicacao: publicacao.datPublicacao ?? '',
              datDespublicar: publicacao.datDespublicar ?? '',
              numRegistro: publicacao.numRegistro ?? '',
            })));
            setTotalPages(data.totalPaginas ?? 1);
          } else {
            setListagemPublicacao([]);
            setTotalPages(1);
          }
        } catch (error) {
          console.error('Erro ao buscar publicações:', error);
        } finally {
          setLoading(false);
        }
      };

      fetchRedeSocial();
    }
  }, [paginaAtual, tamanhoPagina, codRede]);

  const getIconAndColor = (codRede: number) => {
    return iconData[codRede] || iconData.default;
  };

  const handleNavigate = (rede: RedeSocial) => {
    navigate(`publicacoes/${rede.codRede}`)
  }

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading
        mt="30px"
        fontWeight="600"
        fontSize="21px"
        color="#6F6F6F"
        w="100%"
      >
        Redes Sociais
      </Heading>

      <Box>
      {loading ? (
        <Flex
          justify="center"
          align="center"
          direction="column"
          w="70%"
          h="90%"
          position='fixed'
        >
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (
        <div className="containerSocial">
          <ul className="configuracoesList d-flex justify-content-start flex-wrap w-100 p-0">
            {listagemIcones.map((rede: RedeSocial) => {
              const { icon, color } = getIconAndColor(rede.codRede);
              return (
                <li key={rede.codRede.toString()} style={{ marginRight: '35px' }} className="teste d-flex flex-column justify-content-between align-content-center mr-4 mt-4">
                  <FormControl p={'5px'}>
                    <Flex alignItems="center">
                      <Button
                        type="submit"
                        m="6px"
                        w={'150px'}
                        h={'150px'}
                        color="#000"
                        bgColor="#f9f9f9"
                        alignItems="center"
                        flexDirection="column"
                        justifyContent="space-evenly"
                        border="0.5px solid #EAEDF3"
                        borderRadius="10px"
                        boxShadow="0px 2px 3px #e5e5e5"
                        transition="transform 0.2s ease, box-shadow 0.2s ease"
                        _hover={{
                          opacity: 0.8,
                          transform: 'scale(0.95)',
                          boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.2)',
                          color: '#2883de'
                        }}
                        onClick={() => handleNavigate(rede)}
                      >
                        <FontAwesomeIcon
                          icon={icon}
                          fontSize={70}
                          color={color}
                        />
                        <Text fontWeight={'normal'}>{rede.dscRede}</Text>
                      </Button>
                    </Flex>
                  </FormControl>
                </li>
              );
            })}
          </ul>
        </div>
      )}
      </Box>
    </Flex>
  );
};

export default ListaIconesPublicacaoRedeSocial;
